import { useState } from 'react'
import { DataTable } from '@/components/ui/DataTable'
import { TableColumn, TablePagination } from '@/types/table'

interface TestData {
  id: number
  name: string
  email: string
  status: string
  created_at: string
}

export default function PaginationTest() {
  const [data] = useState<TestData[]>(() => {
    // Generate 100 test records
    const records: TestData[] = []
    for (let i = 1; i <= 100; i++) {
      records.push({
        id: i,
        name: `User ${i}`,
        email: `user${i}@example.com`,
        status: i % 3 === 0 ? 'active' : i % 3 === 1 ? 'pending' : 'inactive',
        created_at: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString(),
      })
    }
    return records
  })

  const [pagination, setPagination] = useState<TablePagination>({
    current: 1,
    pageSize: 10,
    total: data.length,
    pageSizeOptions: [5, 10, 20, 50],
  })

  const columns: TableColumn<TestData>[] = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: 'id',
      sortable: true,
    },
    {
      key: 'name',
      title: 'Name',
      dataIndex: 'name',
      sortable: true,
      filterable: true,
    },
    {
      key: 'email',
      title: 'Email',
      dataIndex: 'email',
      sortable: true,
      filterable: true,
    },
    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      sortable: true,
      filterable: true,
      filterType: 'select',
      filterOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Pending', value: 'pending' },
        { label: 'Inactive', value: 'inactive' },
      ],
    },
    {
      key: 'created_at',
      title: 'Created',
      dataIndex: 'created_at',
      sortable: true,
      render: value => new Date(value).toLocaleDateString(),
    },
  ]

  return (
    <div className="min-h-screen bg-gray-900 p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-white mb-6">Pagination Test</h1>
        <p className="text-gray-300 mb-6">
          This page tests the pagination functionality with 100 test records.
        </p>

        <DataTable
          columns={columns}
          data={data}
          pagination={pagination}
          onPageChange={(page, pageSize) => {
            setPagination(prev => ({ ...prev, current: page, pageSize }))
          }}
          searchable={true}
          showStats={true}
          showSearch={true}
          showFilters={true}
          showPagination={true}
          striped={true}
          hoverable={true}
          bordered={true}
        />
      </div>
    </div>
  )
}

